






















import { defineComponent } from "@vue/composition-api";

import { TenantData } from '@/views/Admin/Channels/channelTypes';


// Components
import BaseAvatar from '@/components/NEW-STRUCTURE/desktop/Admin/components/BaseAvatar.vue';


export default defineComponent({
    components: {
        BaseAvatar,
    },
    props: {
        tenant: TenantData,
        checked: Boolean,
    },
    setup(props, context) {
    },
});
